// extracted by mini-css-extract-plugin
module.exports = {"playIcon":"PlayIcon_playIcon__M2_nJ","rightTriangle":"PlayIcon_rightTriangle__Ck4px","circle":"PlayIcon_circle__2C_uj"};